import graphQl from '../../../../services/graphQl';
import { AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { State } from './detail.store';
import { Context } from '@/utils/types/global';
import store from '@/store';
import * as types from '@/components/Database/database.types';

const actions: ActionTree<State, any> = {
  getDatabaseInstances(
    context: Context,
    params: { duration: any; serviceId: any; properties: any; pagination: any; keyword: any }
  ) {
    return graphQl
      .query('queryServiceInstancesWithTotalCount')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setDatabaseInstances', res.data.data.instanceId.serviceInstances);
        if (res.data.data.instanceId.serviceInstances.length > 0) {
          const curIns = res.data.data.instanceId.serviceInstances.find(
            ins =>
              ins.key ===
              context.rootState.databaseState.detail.currentDatabaseInstance.key
          );
          context.commit(
            'setCurrentDatabaseInstance',
            curIns || res.data.data.instanceId.serviceInstances[0]
          );
        } else {
          context.commit(
            'setCurrentDatabaseInstance', '');
        }
        return res;
      });
  },

  getClusterDetails(
    context: Context,
    params: { duration: any; serviceId: any; properties: any }
  ) {
    return graphQl
    .query('queryServiceInstancesWithTotalCount')
    .params(params)
    .then((res: AxiosResponse) => {
      context.commit('setClusters', res.data.data.instanceId.serviceInstances);
      if (res.data.data.instanceId && res.data.data.instanceId.serviceInstances.length > 0) {
        const curIns = res.data.data.instanceId.serviceInstances.find(
          ins =>
            ins.key ===
            context.rootState.databaseState.detail.currentCluster.key
        );
        context.commit(
          'setCurrentCluster',
          curIns || res.data.data.instanceId.serviceInstances[0]
        );
      } else {
        context.commit('setCurrentCluster', '');
      }
      return res;
    });
  },

  getBucketDetails(
    context: Context,
    params: { duration: any; serviceId: string; properties:any, meta_property_3: string, pagination: any; keyword: any}
  ) {
    return graphQl
    .query('queryBucketDetails')
    .params(params)
    .then((res:AxiosResponse) => {
      context.commit('setBuckets', res.data.data.instanceId);
      if (res.data.data.instanceId.length > 0) {
           const curBucket = res.data.data.instanceId.find(
            bucket =>
              bucket.key ===
              context.rootState.databaseState.detail.currentBucket.key
          );
          context.commit(
            'setCurrentBucket',
            curBucket || res.data.data.instanceId[0]
          );
      }else {
        context.commit('setCurrentBucket', '');
      }

    });
  },

  getInstanceByMetaProperty(
    context: Context,
    params: { duration: any; serviceId: string; properties:any, meta_property_3: string}
  ) {
    return graphQl
    .query('queryInstancesByMetaProperty')
    .params(params)
    .then((res:AxiosResponse) => {
      context.commit('setDatabaseInstances', res.data.data.instanceId.serviceInstances);
      if (res.data.data.instanceId.serviceInstances.length > 0) {
        const curInstance = res.data.data.instanceId.serviceInstances.find(
          instance =>
          instance.key ===
            context.rootState.databaseState.detail.currentDatabaseInstance.key
        );
        context.commit(
          'setCurrentDatabaseInstance',
          curInstance || res.data.data.instanceId.serviceInstances[0]
        );
      } else {
        context.commit('setCurrentDatabaseInstance', '');
      }

    }
  );
},
getInstances(
  context: Context,
  params: { duration: any; serviceId: any; properties: any }
) {
  return graphQl
    .query('queryInstancesInfo')
    .params(params)
    .then((res: AxiosResponse) => {
      const clusterLabel = context.rootState.databaseState.detail.currentCluster.label
      if(store.getters['databaseState/databaseCommonState/getCurrentDatabase'].key === types.DatabaseTypes.my) {
        const modifiedInstances = (res.data?.data?.instanceId || []).map((instance) => {
          if (instance.label && instance.label.startsWith(clusterLabel)) {
            instance.label = instance.label.substring(clusterLabel.length+1);
          }
          return instance;
        });
        context.commit('setDatabaseInstances', modifiedInstances);
      }
      else {
        context.commit('setDatabaseInstances', res.data.data.instanceId);
      }
      if (res.data.data.instanceId.length > 0) {
        const curIns = res.data.data.instanceId.find(
          ins =>
            ins.key ===
            context.rootState.databaseState.detail.currentDatabaseInstance.key
        );
        context.commit(
          'setCurrentDatabaseInstance',
          curIns || res.data.data.instanceId[0]
        );
      } else {
        context.commit('setCurrentDatabaseInstance', '');
      }
    });
},

getInstancesByMetaPropertyWithTotal(
  context: Context,
  params: { duration: any; serviceId: string; properties:any, meta_property_3: string}
)  {
  return graphQl
  .query('queryInstancesByMetaPropertyWithTotal')
  .params(params)
  .then((res:AxiosResponse) => {
    context.commit('setDatabaseInstances', res.data.data.instanceId.serviceInstances);
    if (res.data.data.instanceId.serviceInstances.length > 0) {
      const curInstance = res.data.data.instanceId.serviceInstances.find(
        instance =>
        instance.key ===
          context.rootState.databaseState.detail.currentDatabaseInstance.key
      );
      context.commit(
        'setCurrentDatabaseInstance',
        curInstance || res.data.data.instanceId.serviceInstances[0]
      );
    } else {
      context.commit('setCurrentDatabaseInstance', '');
    }
    return res;
  }
);
}

}

export default actions;
